import { brand } from '@/brands';
import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
// import BottomNav from '@/components/common/BottomNav';
import DownloadApkPopup from '@/components/DownloadApkPopup';
import Header from '@/components/Header';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { usePaymentSocket } from '@/hooks/usePaymentSocket';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = useSelector((state: RootState) => state.auth.session?.accessToken ?? null);
  usePaymentSocket(token);
  // Deposit / Withdraw / FD pages have their own header — hide the main site header there.
  const { pathname } = useLocation();
  const hideHeader = pathname.includes('/user/deposit') || pathname.includes('/user/fd');
  return (
    <div className="min-h-screen flex flex-col">
      {!hideHeader && <Header onMenuClick={() => setIsSidebarOpen(true)} />}

      <div className="flex flex-1">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        <main className="flex-1 overflow-x-hidden">
          <Outlet />
        </main>
      </div>

      <Footer />

      {/* Floating Download APK bar — dismiss on ✖, returns on refresh */}
      {brand.features.downloadApk && <DownloadApkPopup />}

      {/* <BottomNav /> */}
    </div>
  );
};

export default MainLayout;
